import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/authService";
import {
  getWorkersList,
  getInviteWorkersListApi,
  getWorkerInformaton,
  getWorkerJobsApi,
  getEmployerJobappliedWorkersListApi,
} from "../../services/workersListApi";
export const getWorkers = createAsyncThunk(
  "workers/getWorkers",
  async (path, thunkAPI) => {
    try {
      const data = await getWorkersList(path);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getEmployerJobappliedWorkersList = createAsyncThunk(
  "workers/getEmployerJobappliedWorkersList",
  async (params, thunkAPI) => {
    try {
      const data = await getEmployerJobappliedWorkersListApi(params);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInviteWorkersList = createAsyncThunk(
  "workers/getInviteWorkers",
  async (params, thunkAPI) => {
    try {
      const data = await getInviteWorkersListApi(params);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getWorkerInfo = createAsyncThunk(
  "workers/getWorkerInformation",
  async (workerId, thunkAPI) => {
    try {
      const data = await getWorkerInformaton(workerId);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getWorkerJobs = createAsyncThunk(
  "workers/getWorkerJobs",
  async (workerId, thunkAPI) => {
    try {
      const data = await getWorkerJobsApi(workerId);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
const workersSlice = createSlice({
  name: "workers",
  initialState: {
    workers: [],
    workerInfo: {},
    inviteWorkersList: [],
    workerJobs: [],
    employerJobappliedWorkersList: [],
  },
  extraReducers: {
    [getWorkers.fulfilled]: (state, action) => {
      state.workers = action.payload.response.data;
    },
    [getWorkers.rejected]: (state) => {
      state.workers = [];
    },
    [getWorkerInfo.fulfilled]: (state, action) => {
      state.workerInfo = action.payload.response.data;
    },
    [getWorkerInfo.rejected]: (state) => {
      state.workerInfo = {};
    },
    [getInviteWorkersList.fulfilled]: (state, action) => {
      state.inviteWorkersList = action.payload.response.data;
    },
    [getInviteWorkersList.rejected]: (state) => {
      state.inviteWorkersList = [];
    },
    [getEmployerJobappliedWorkersList.fulfilled]: (state, action) => {
      state.employerJobappliedWorkersList = action.payload.response.data;
    },
    [getEmployerJobappliedWorkersList.rejected]: (state) => {
      state.employerJobappliedWorkersList = [];
    },
    [getWorkerJobs.fulfilled]: (state, action) => {
      state.workerJobs = action.payload.response.data;
    },
    [getWorkerJobs.rejected]: (state) => {
      state.workerJobs = [];
    },
  },
});
const { reducer } = workersSlice;
export default reducer;
